// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"52a99c6d","238":"bba7b826","239":"4967b8b7","355":"cca173c5","633":"b97f29d0","732":"c8889e0c"}[chunkId] + ".chunk.js";
};